import { instrumentGroup } from '../shared/holding-groups';
import type { HoldingGroupDto, InstrumentDto } from '../shared/types';

const compareSymbols = (a: string, b: string) => a.localeCompare(b, 'en', { sensitivity: 'base', numeric: true });
const compareGroupNames = (a: string, b: string) => a.localeCompare(b, ['th', 'en'], { sensitivity: 'base', numeric: true });

export function sortHoldingGroupsByName(groups: HoldingGroupDto[]) {
  return [...groups].sort((a, b) => compareGroupNames(a.name, b.name));
}

export function selectableHoldingGroupInstruments(
  instruments: InstrumentDto[],
  groups: HoldingGroupDto[],
  marketGroup: HoldingGroupDto['marketGroup'],
  editingGroupId?: string,
) {
  const assignedToOtherGroups = new Set(groups
    .filter((group) => group.id !== editingGroupId)
    .flatMap((group) => group.instrumentIds));

  return instruments
    .filter((instrument) => instrumentGroup(instrument) === marketGroup && !assignedToOtherGroups.has(instrument.id))
    .sort((a, b) => compareSymbols(a.symbol, b.symbol));
}

export function holdingGroupSymbols(instruments: InstrumentDto[], instrumentIds: string[]) {
  const selectedIds = new Set(instrumentIds);
  return instruments
    .filter((instrument) => selectedIds.has(instrument.id))
    .map((instrument) => instrument.symbol)
    .sort(compareSymbols);
}
